import styled from "styled-components";
import {media} from "../../theme";

export const StyledTableContainer = styled.div`
    padding: 40px;
    min-width: 40%;
    max-width: 90%;
    background-color: ${({theme}) => theme.palette.background.paper};
    border: 1px solid rgba(224, 224, 224, 1);
    margin: 40px auto;
    border-radius: 20px;
    position: relative;
`;


export const ControlsRow = styled.div`
    width: 100%;
    display: flex;
    gap: 10px; 
    margin-bottom: 36px;
    flex-wrap: wrap;
    
    flex-direction: column;
    align-items: stretch;
    
    ${media.sm} {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    
    ${media.md} {
        gap: 12px;
    }
`;

export const SearchWrapper = styled.div`
    flex: 1 1 100%;
    width: 100%;
    
    ${media.sm} {
        flex: 1 1 55%;
        min-width: 120px;
        width: auto;
    }
`;

export const PageSizeWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    
    ${media.sm} {
        width: auto;
        display: block;
        justify-content: initial;
        flex: 0 0 auto;
    }
`;

export const PaginationWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
    
    ${media.sm} {
        margin-top: 24px;
    }
    
    .MuiPaginationItem-root {
        font-size: 0.8rem;
        min-width: 32px;
        height: 32px;
    }
    
    ${media.sm} {
        .MuiPaginationItem-root {
              font-size: 0.875rem;
              min-width: 40px;
              height: 40px;
        }
    }
`;